"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "paullo": {
    "cb7de67c": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "bentivoglio": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6e9216b7": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-inzogo": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6cda639e": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-nuova": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f62fc376": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "casello": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9818a397": [{
      "hkey": "0d1585dd",
      "slug": "conterico",
      "name": "Conterico",
      "primary": true,
      "skipSearch": false
    }],
    "conterico-sopra": [{
      "hkey": "0d1585dd",
      "slug": "conterico",
      "name": "Conterico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "58a91808": [{
      "hkey": "0d1585dd",
      "slug": "conterico",
      "name": "Conterico",
      "primary": true,
      "skipSearch": false
    }],
    "conterico-sotto": [{
      "hkey": "0d1585dd",
      "slug": "conterico",
      "name": "Conterico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "paullo"
    }],
    "0d04a07a": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "cossaghetto": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d0e158a7": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "cossago": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fb11c78a": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "fornace": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "764facdf": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "gere": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "816db071": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "linate": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4456fb60": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "ronco": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d4c12af0": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "sant-antonio": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "29e5e365": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "tombona": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f6b4d4dd": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "skipSearch": false
    }],
    "villambrera": [{
      "hkey": "102d93d4",
      "slug": "paullo",
      "name": "Paullo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;